import { currency } from "~/schemas/schema.currencies";
import {
  EDIT_DEFAULT_CURRENCY_LOADING,
  EDIT_DEFAULT_CURRENCY_SUCCESS,
  EDIT_DEFAULT_CURRENCY_ERROR,
} from "~/store/action_types";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch.jsx";

export const editDefaultCurrency = (currency_id) => {
  return {
    types: [EDIT_DEFAULT_CURRENCY_LOADING, EDIT_DEFAULT_CURRENCY_SUCCESS, EDIT_DEFAULT_CURRENCY_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/currencies/default`,
        method: "put",
        body: {
          currency_id,
        },
      }),
    payload: {
      currency_id,
      schema: {
        single: currency,
      },
    },
  };
};
